import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteEmailCycleRPC } from "./deleteEmailCycleRPC";

export class DeleteEmailCycleRPCClientImpl extends DeleteEmailCycleRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteEmailCycleRPC.Request): Promise<LeoRPCResult<DeleteEmailCycleRPC.Response, DeleteEmailCycleRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/DeleteEmailCycle",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteEmailCycleRPC.ResponseDTO,
      DeleteEmailCycleRPC.Errors.ErrorsDTO,
      DeleteEmailCycleRPC.Response,
      DeleteEmailCycleRPC.Errors.Errors
    >(
      response,
      "email-cycle/DeleteEmailCycle",
      DeleteEmailCycleRPC.Response.fromDTO,
      DeleteEmailCycleRPC.Errors.fromDTO
    );
  }
}
